module.exports = __webpack_public_path__ + "static/img/msdsbg.3fff32b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msdsbg.jpg
// module id = l4Io
// module chunks = 1